import { createAction, createReducer } from 'deox';

export type ConsumerSearchResult = 'existingAccount' | 'error' | undefined;

export interface EnhancedCheckout {
  consumerSearchResult: ConsumerSearchResult;
  applicationStartEventSent: boolean;
}

const defaultState: EnhancedCheckout = {
  consumerSearchResult: undefined,
  applicationStartEventSent: false,
};

export const mergeEnhancedCheckoutState = createAction(
  'SET_ENHANCED_CHECKOUT_STATE',
  resolve => (enhancedCheckout: Partial<EnhancedCheckout>) =>
    resolve(enhancedCheckout),
);

export const enhancedCheckoutReducer = createReducer(
  defaultState,
  handleAction => [
    handleAction(mergeEnhancedCheckoutState, (state, { payload }) => ({
      ...state,
      ...payload,
    })),
  ],
);

interface MountedState {
  enhancedCheckout: EnhancedCheckout;
}

export const selectEnhancedCheckout = (
  state: MountedState,
): EnhancedCheckout => {
  return state.enhancedCheckout;
};

export default enhancedCheckoutReducer;
